'use client';

import { useEffect, useState } from 'react';
import { useBreakpoint } from 'hooks/useBreakpoints';
import { CardsVerticalScrollProps } from './types';
import CardsVerticalScrollDesktop from './CardsVerticalScrollDesktop';
import CardsVerticalScrollMobile from './CardsVerticalScrollMobile';

const CardsVerticalScroll = (props: CardsVerticalScrollProps) => {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => setIsMounted(true), []);

  const { isAboveMd } = useBreakpoint('md');
  const isDesktop = isMounted ? isAboveMd : false;

  return <>{isDesktop ? <CardsVerticalScrollDesktop {...props} /> : <CardsVerticalScrollMobile {...props} />}</>;
};

export default CardsVerticalScroll;
